import { useState, useEffect, useCallback } from 'react';
import { hrms } from '../../services/api';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import Modal from '../../components/common/Modal';
import { theme } from '../../theme';


function HonoreeBadge({ h }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: theme.bgSecondary, borderRadius: '2rem', padding: '0.25rem 0.75rem 0.25rem 0.25rem', border: `1px solid ${theme.border}` }}>
      {h.profile_photo ? (
        <img
          src={`http://localhost:8000/${h.profile_photo}`}
          alt={h.full_name}
          style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
        />
      ) : null}
      <div style={{
        width: 28, height: 28, borderRadius: '50%', background: '#FEF3C7',
        display: h.profile_photo ? 'none' : 'flex',
        alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem', flexShrink: 0,
      }}>🏅</div>
      <div>
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: theme.text }}>{h.full_name}</span>
        {h.department && <span style={{ fontSize: '0.7rem', color: theme.textMuted, marginLeft: '0.3rem' }}>· {h.department}</span>}
      </div>
    </div>
  );
}

function HofCard({ entry, onEdit, onDelete }) {
  const [confirmDel, setConfirmDel] = useState(false);

  return (
    <div style={{ background: theme.white, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
      {/* Banner image or gradient header */}
      {entry.image_path ? (
        <div style={{ height: '160px', overflow: 'hidden' }}>
          <img
            src={`http://localhost:8000/${entry.image_path}`}
            alt={entry.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
      ) : (
        <div style={{ height: '80px', background: `linear-gradient(135deg, ${theme.dark} 0%, #1a3a5c 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
          🏆
        </div>
      )}

      <div style={{ padding: '1rem 1.25rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: theme.text }}>{entry.title}</h3>
          <div style={{ display: 'flex', gap: '0.375rem', flexShrink: 0 }}>
            <button onClick={() => onEdit(entry)} style={{ background: 'none', border: `1px solid ${theme.border}`, borderRadius: '0.375rem', padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.75rem', color: theme.textMuted }}>Edit</button>
            {confirmDel ? (
              <>
                <button onClick={() => onDelete(entry.id)} style={{ background: theme.danger, border: 'none', borderRadius: '0.375rem', padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.75rem', color: '#fff', fontWeight: 600 }}>Confirm</button>
                <button onClick={() => setConfirmDel(false)} style={{ background: 'none', border: `1px solid ${theme.border}`, borderRadius: '0.375rem', padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.75rem', color: theme.textMuted }}>Cancel</button>
              </>
            ) : (
              <button onClick={() => setConfirmDel(true)} style={{ background: 'none', border: `1px solid ${theme.danger}40`, borderRadius: '0.375rem', padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.75rem', color: theme.danger }}>Delete</button>
            )}
          </div>
        </div>

        {entry.achievement_date && (
          <p style={{ margin: '0 0 0.5rem', fontSize: '0.75rem', color: theme.textMuted }}>
            🗓 {new Date(entry.achievement_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        )}

        {entry.description && (
          <p style={{ margin: '0 0 0.75rem', fontSize: '0.85rem', color: theme.gray, lineHeight: 1.5 }}>
            {entry.description}
          </p>
        )}

        {entry.honorees?.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
            {entry.honorees.map(h => <HonoreeBadge key={h.employee_id} h={h} />)}
          </div>
        )}

        {entry.expiry_date && (
          <p style={{ margin: '0.75rem 0 0', fontSize: '0.7rem', color: theme.textMuted }}>
            Visible until {new Date(entry.expiry_date).toLocaleDateString()}
          </p>
        )}
      </div>
    </div>
  );
}

function HofModal({ entry, employees, onClose, onSaved }) {
  const isEdit = !!entry;
  const [form, setForm] = useState({
    title: entry?.title || '',
    description: entry?.description || '',
    achievement_date: entry?.achievement_date || '',
    expiry_date: entry?.expiry_date || '',
    employee_ids: (entry?.honorees || []).map(h => h.employee_id),
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(entry?.image_path ? `http://localhost:8000/${entry.image_path}` : null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [empSearch, setEmpSearch] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const toggleEmployee = (id) => {
    set('employee_ids', form.employee_ids.includes(id)
      ? form.employee_ids.filter(e => e !== id)
      : [...form.employee_ids, id]
    );
  };

  const handleImage = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setImageFile(f);
    setImagePreview(URL.createObjectURL(f));
  };

  const handleSave = async () => {
    if (!form.title.trim()) { setError('Title is required.'); return; }
    if (form.employee_ids.length === 0) { setError('Select at least one employee.'); return; }
    setSaving(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('title', form.title.trim());
      if (form.description) fd.append('description', form.description.trim());
      if (form.achievement_date) fd.append('achievement_date', form.achievement_date);
      if (form.expiry_date) fd.append('expiry_date', form.expiry_date);
      fd.append('employee_ids', JSON.stringify(form.employee_ids));
      if (imageFile) fd.append('image', imageFile);

      if (isEdit) {
        await hrms.updateHallOfFame(entry.id, fd);
      } else {
        await hrms.createHallOfFame(fd);
      }
      onSaved();
    } catch (err) {
      setError(err?.response?.data?.detail || 'Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  const filteredEmps = employees.filter(e =>
    !empSearch || e.full_name.toLowerCase().includes(empSearch.toLowerCase()) ||
    (e.department_name || '').toLowerCase().includes(empSearch.toLowerCase())
  );

  const inputStyle = { width: '100%', padding: '0.5rem 0.75rem', border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', boxSizing: 'border-box', background: theme.white, color: theme.text };
  const labelStyle = { fontSize: '0.8rem', fontWeight: 600, color: theme.textMuted, display: 'block', marginBottom: '0.3rem' };

  return (
    <Modal title={isEdit ? 'Edit Hall of Fame Entry' : 'New Hall of Fame Entry'} isOpen onClose={onClose} maxWidth="640px">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {error && <div style={{ background: '#FEE2E2', color: '#B91C1C', padding: '0.625rem 0.875rem', borderRadius: '0.5rem', fontSize: '0.85rem' }}>{error}</div>}

        {/* Title */}
        <div>
          <label style={labelStyle}>Achievement Title *</label>
          <input style={inputStyle} value={form.title} onChange={e => set('title', e.target.value)} placeholder="e.g. Employee of the Month – March 2026" />
        </div>

        {/* Description */}
        <div>
          <label style={labelStyle}>Description</label>
          <textarea style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }} value={form.description} onChange={e => set('description', e.target.value)} placeholder="What did they achieve?" />
        </div>

        {/* Date row */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div>
            <label style={labelStyle}>Achievement Date</label>
            <input type="date" style={inputStyle} value={form.achievement_date} onChange={e => set('achievement_date', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Visible Until (Expiry)</label>
            <input type="date" style={inputStyle} value={form.expiry_date} onChange={e => set('expiry_date', e.target.value)} />
          </div>
        </div>

        {/* Image upload */}
        <div>
          <label style={labelStyle}>Award Image (optional)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: theme.bgSecondary, border: `1px solid ${theme.border}`, borderRadius: '0.5rem', padding: '0.5rem 1rem', fontSize: '0.8rem', color: theme.text, fontWeight: 600 }}>
              📷 Choose Image
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImage} />
            </label>
            {imagePreview && (
              <img src={imagePreview} alt="preview" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: '0.5rem', border: `1px solid ${theme.border}` }} />
            )}
          </div>
        </div>

        {/* Employee picker */}
        <div>
          <label style={labelStyle}>Honorees * ({form.employee_ids.length} selected)</label>
          <input style={{ ...inputStyle, marginBottom: '0.5rem' }} placeholder="Search employees..." value={empSearch} onChange={e => setEmpSearch(e.target.value)} />
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: `1px solid ${theme.border}`, borderRadius: '0.5rem' }}>
            {filteredEmps.map(emp => {
              const selected = form.employee_ids.includes(emp.id);
              return (
                <label key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 0.75rem', cursor: 'pointer', background: selected ? `${theme.primary}10` : 'transparent', borderBottom: `1px solid ${theme.border}` }}>
                  <input type="checkbox" checked={selected} onChange={() => toggleEmployee(emp.id)} />
                  {emp.profile_photo ? (
                    <img src={`http://localhost:8000/${emp.profile_photo}`} alt={emp.full_name} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                  ) : (
                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: theme.bgSecondary, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.85rem' }}>👤</div>
                  )}
                  <div>
                    <div style={{ fontSize: '0.85rem', fontWeight: 600, color: theme.text }}>{emp.full_name}</div>
                    {emp.department_name && <div style={{ fontSize: '0.72rem', color: theme.textMuted }}>{emp.department_name}</div>}
                  </div>
                </label>
              );
            })}
            {filteredEmps.length === 0 && <p style={{ textAlign: 'center', color: theme.textMuted, fontSize: '0.8rem', padding: '1rem' }}>No employees found</p>}
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', paddingTop: '0.5rem' }}>
          <Button variant="secondary" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : (isEdit ? 'Update Entry' : 'Create Entry')}</Button>
        </div>
      </div>
    </Modal>
  );
}

function HallOfFame() {
  const [entries, setEntries] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null | 'create' | entry object

  const load = useCallback(async () => {
    setLoading(true);
    const [hofRes, empRes] = await Promise.allSettled([
      hrms.getHallOfFame(),
      hrms.getEmployees(),
    ]);
    if (hofRes.status === 'fulfilled') setEntries(hofRes.value.data || []);
    if (empRes.status === 'fulfilled') {
      const d = empRes.value.data;
      setEmployees(Array.isArray(d) ? d : (d?.items || []));
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id) => {
    try {
      await hrms.deleteHallOfFame(id);
      load();
    } catch { alert('Failed to delete entry.'); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: theme.text }}>🏆 Hall of Fame</h1>
          <p style={{ margin: '0.25rem 0 0', fontSize: '0.875rem', color: theme.textMuted }}>Recognize and celebrate outstanding employee achievements</p>
        </div>
        <Button onClick={() => setModal('create')}>+ New Entry</Button>
      </div>

      {/* Stats row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
        {[
          { label: 'Total Entries', value: entries.length, icon: '🏆', color: '#F59E0B' },
          { label: 'Honored Employees', value: [...new Set(entries.flatMap(e => (e.honorees || []).map(h => h.employee_id)))].length, icon: '🌟', color: '#8B5CF6' },
          { label: 'This Year', value: entries.filter(e => e.achievement_date?.startsWith(new Date().getFullYear())).length, icon: '📅', color: '#10B981' },
        ].map(s => (
          <div key={s.label} style={{ background: theme.white, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
            <div style={{ width: 44, height: 44, borderRadius: '0.625rem', background: `${s.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem' }}>{s.icon}</div>
            <div>
              <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: theme.text }}>{s.value}</p>
              <p style={{ margin: 0, fontSize: '0.75rem', color: theme.textMuted }}>{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Entries grid */}
      {loading ? (
        <p style={{ textAlign: 'center', color: theme.textMuted, padding: '3rem 0' }}>Loading…</p>
      ) : entries.length === 0 ? (
        <Card>
          <div style={{ textAlign: 'center', padding: '3rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🏆</div>
            <p style={{ color: theme.textMuted, margin: 0 }}>No Hall of Fame entries yet. Create the first one!</p>
          </div>
        </Card>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '1.25rem' }}>
          {entries.map(entry => (
            <HofCard key={entry.id} entry={entry} onEdit={e => setModal(e)} onDelete={handleDelete} />
          ))}
        </div>
      )}

      {/* Modal */}
      {modal && (
        <HofModal
          entry={modal === 'create' ? null : modal}
          employees={employees}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </div>
  );
}

export default HallOfFame;
